module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-8-9bdefcdf58a50e2ea6d5285301308c91.webp";